/**
 * Build a https://wa.me/ link from a phone number.
 *
 * Handles Malaysian local numbers (starting with "0") by replacing the
 * leading zero with the country code "6" (→ 60…).
 */
export function whatsappLink(phone: string | null | undefined): string | null {
  if (!phone) return null

  let digits = phone.replace(/\D/g, '')
  if (!digits) return null

  // Malaysian local format: 0xx → 60xx
  if (digits.startsWith('0')) {
    digits = '6' + digits
  }

  return `https://wa.me/${digits}`
}
